// Components
import { Link } from '@tracklib/kit'

// Types
import { Genre } from 'types'

// Utils
import styles from './infoitem2.css'

type GenresProps = {
  genres: Array<Genre>
  showAll?: boolean
  displayAsRow?: boolean
  isModal: boolean
  modalOpen?: boolean
  toggleModalOpen?: (open: boolean) => null
}

const Genres = ({ genres, showAll, displayAsRow, modalOpen, isModal, toggleModalOpen }: GenresProps): JSX.Element | null => {
  if (!genres.length) {
    return null
  }

  const firstGenre = genres[0]
  const genresLength = genres.length

  if (showAll || isModal) {
    return (
      <>
        {genres
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((x, i) => (
            <span key={String(x.id)}>
              <Link to={`/genre/${x.slug}/`}>{x.name}</Link>
              {showAll && displayAsRow && genresLength !== i + 1 && <span>&nbsp;&nbsp;</span>}
            </span>
          ))}
      </>
    )
  }

  return (
    <span>
      <Link to={`/genre/${firstGenre.slug}/`}>{firstGenre.name}</Link>
      {genresLength > 1 && (
        <>
          <span className={styles.plus}>&nbsp;&#43;&nbsp;</span>
          <Link onClick={() => toggleModalOpen && toggleModalOpen(!modalOpen)}>{genresLength - 1} more</Link>
        </>
      )}
    </span>
  )
}

export default Genres
